<template>
  <q-dialog
    class="base-modal"
    transition-hide="slide-down"
    transition-show="fade"
    transition-duration="200"
    :model-value="state.open"
    @update:model-value="close"
  >
    <q-card
      class="q-dialog-card rounded-xl"
      :style="{
        maxWidth: state.style.width,
        minHeight: state.style.height,
      }"
    >
      <!-- @slot Onde entra o Header, com default -->
      <slot
        name="header"
        :subtitle="state.header.subtitle"
        :title="state.header.title"
        :close="close"
      >
        <HeaderModalBase
          :title="state.header.title"
          @click:close="close"
        />
      </slot>

      <!-- CONTENT -->
      <div class="q-dialog-content" :class="state.contentClass">
        <!-- @slot Onde entra o conteudo do modal -->
        <slot name="content" :data="state.data">
          <h2 class="text-title-2 flex-1 grid place-items-center">
            Conteúdo do modal
          </h2>
        </slot>
      </div>
      <!--  -->
    </q-card>
  </q-dialog>
</template>

<script setup>
import HeaderModalBase from 'components/Header/HeaderModalBase.vue'

//
const props = defineProps({
  state: {
    type: Object,
    required: true,
  },
  open: {
    type: Function,
    required: true,
  },
  close: {
    type: Function,
    required: true,
  },
})
</script>

<style lang="sass" scoped>
.base-modal
  border: none

  .q-dialog-card
    height: auto
    width: 100%
    overflow: hidden
    display: flex
    flex-direction: column

    .q-dialog-content
      flex: 1
      display: flex
      flex-direction: column
      max-height: calc(98vh - 5rem)
      overflow-y: auto
      height: 100%
      padding: 1.5rem
</style>
